import {useEffect, useState} from "react"
import ModDataService from "./services/mod.service"
import React from 'react';
import {isAxiosError} from "axios";
import TextareaAutosize from 'react-textarea-autosize'
import httpCommon from "./http-common";
import {CSelectList, composer} from "./components/Edit.tsx";
import cds from "./services/composer.service";

type tune_draft = {
  "title"?: string
  "bio"?: string
  "alternative_title"?: string
  //"Composers"?: composer[]
  "form"?: string
  //"notable_recordings"?: string[]
  //"keys"?: string[]
  //"styles"?: string[]
  //"tempi"?: string[]
  //"contrafacts"?: string[] // In the future, these could link to other tunes
  "id"?: number
  "year"?: number
  "has_lyrics"?: boolean
  "TuneId"?: number
  "UserId"?: number
  "pending_review"?: boolean
  "accepted"?: boolean
  "Composers"?: composer[] //Can't be bothered to type this rn
}

type composer_draft = {
  "name"?: string
  "id"?: number
  "birth"?: string
  "death"?: string
  "bio"?: string
  "pending_review"?: boolean
  "accepted"?: boolean
}

//Defaults for both composers and tunes.
const defaults = {
  "title": "New song",
  "name" : "New composer",
  "alternative_title": "",
  "bio": "",
  "composers": [],
  "form": "",
  "birth": "",
  "death": "",
  "notable_recordings": [],
  "keys": [],
  "styles": [],
  "tempi": [],
  "contrafacts": [], 
  "played_at": [], 
  "composer_placeholder": "",
  "accepted": false,
  "pending_review": true,
  "id": -1
}

const tuneDraftEditorFields = new Map<keyof tune_draft, string>([
  ["title", "Title:"],
  ["alternative_title", "Alternative title"],
  ["bio", "Bio:"],
  ["form", "Form"],
  ["year", "Year:"],
])

const composerDraftEditorFields = new Map<keyof composer, string>([
  ["name", "Name:"],
  ["birth", "Birth:"],
  ["death", "Death:"],
  ["bio", "Bio:"],
]);
const composerDraftEditorFieldsEntries = Array.from(composerDraftEditorFields.entries());
const tuneDraftEditorFieldsEntries = Array.from(tuneDraftEditorFields.entries());


function EditField(
  {attr, data, setModified}:
  {attr: string, data: tune_draft, setModified: Function}
){
  let value = data[attr] ? data[attr] : defaults[attr];
  //Notice the pattern below, it can be abstracted. Particularly, name, autoComplete, and onChange
  //<input classname=..."
  //  defaultValue?
  //  type?
  //  name={attr}
  //  autoComplete="off"
  //  onChange{() => {setModified(true)}}
  //  min?
  //  max?
  switch(attr){
    case "bio":
      return(<TextareaAutosize className="bg-black text-base"
        defaultValue={data[attr] ? data[attr] : ""}
        placeholder='(Empty)'
        name={attr}
        autoComplete='off'
        onChange={() => {setModified(true)}}
        style={{resize: "none"}}
        />);
      case "birth":
      case "death":
      return(
        <input className="bg-black text-base"
          type="date"
          name={attr}
          onChange={() => {setModified(true)}}
          defaultValue={data[attr] ? (data[attr] as string).split("T")[0] : ""}
        />
      );
      case "year":
      return(
        <input className="bg-black text-base"
          type="number"
          name={attr}
          defaultValue={data[attr] ? data[attr] : 0}
          min={0}
          max={3000}
          onChange={() => {setModified(true)}}
        />
      );

  }
  switch(typeof value){
    case "string":
      return(<input className="bg-black text-base"
        defaultValue={data[attr] ? data[attr] : ""}
        placeholder='(Empty)'
        name={attr}
        autoComplete='off'
        onChange={() => {setModified(true)}}
        />);
    case "boolean":
      return(<input className="bg-black text-base"
          type="checkbox"
          name={attr}
          defaultValue={data[attr] ? data[attr] : false}
          onChange={() => {setModified(true)}}
        />);
  }
}

function DraftEditor({
  draft, setEditing, composers, reloadDrafts, isComposer
}:{
  draft: tune_draft, setEditing: (editing: boolean) => void, composers: composer[], reloadDrafts: Function, isComposer: boolean
}){
  const [modified, setModified] = useState(false);
  const [newComposers, setNewComposers] = useState([] as composer[]); 
  useEffect(() => {
    setNewComposers("Composers" in draft ? draft.Composers as Array<composer> : []);
  }, [draft, draft.id]);
  function handleSubmit(e: React.FormEvent){
    //Prevent browser from reloading page
    e.preventDefault();

    //Read form data
    const form = e.target;
    const formData = new FormData(form as HTMLFormElement);

    if(isComposer){
      if(modified){
        const formJson = Object.fromEntries(formData.entries()) as composer_draft;
        httpCommon.put(`/moderation/composer/update/${formJson.id}`).then(() => {
          setModified(false);
          reloadDrafts();
        });
      }else{
        httpCommon.put(`/moderation/composer/accept/${draft.id}`).then(() => {
          setEditing(false);
          reloadDrafts();
        });
      }
    }else{
      if(modified){
        const formJson = Object.fromEntries(formData.entries()) as tune_draft;
        formJson["composers"] = newComposers.map(comp => comp.id);
        httpCommon.put(`/moderation/tune/update/${formJson.id}`).then(() => {
          setModified(false);
          reloadDrafts();
        });
      }else{
        httpCommon.put(`/moderation/tune/accept/${draft.id}`).then(() => {
          setEditing(false);
          reloadDrafts();
        });
      }
    }
    return;
  }
  function reject(dbId: number){
    if(isComposer){
      httpCommon.put(`/moderation/composer/accept/${dbId}`);
    }else{
      httpCommon.put(`/moderation/tune/accept/${dbId}`);
    }
    setEditing(false);
    reloadDrafts();
  };
  const listItems = (isComposer ? composerDraftEditorFieldsEntries : tuneDraftEditorFieldsEntries).map( ([attr, pretty]) =>
      <div className='m-5 bg-slate-800' key={attr}>
        <label className='bg-slate-800'>
          <p className='text-2xl'>
            {pretty}
          </p>
          <EditField attr={attr} data={draft} setModified={setModified}/>
        </label>
      </div>
  );
  return(
    <div>
      <form id="edit-form" className='m-1 h-screen' onSubmit={handleSubmit}>
        {!isComposer && <CSelectList list={composers} newComposers={newComposers} setNewComposers={(arg) => {setNewComposers(arg); setModified(true);}}/>}
        { listItems }
        <div className="flex-row flex">
          <div className="m-2">
            <button className="bg-slate-700 p-2 m-3 text-lg" type="reset" onClick={() => {
              setModified(false);
            }}>
              Reset
            </button>
            <button className="bg-slate-700 p-2 m-3 text-lg" type="submit" onSubmit={handleSubmit}>
              {modified ? "Update Draft" : "Accept Draft"}
            </button>
            <button className='m-3 p-2 bg-slate-700 text-lg' onClick={() => {
              reject(draft.id as number);
            }}>
              Reject
            </button>
            <button className='m-3 p-2 bg-slate-700 text-lg' onClick={() => {
              setEditing(false);
            }}>
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

enum BoolFilterState{
  "OFF" = 0,
  "YES" = 1,
  "NO" = 2,
};
export default function ModMenu(){
  const [tuneDrafts, setTuneDrafts] = useState([] as tune_draft[]);
  const [composerDrafts, setComposerDrafts] = useState([] as composer_draft[])
  const [err, setErr] = useState("An unknown error occured");
  const [errPresent, setErrPresent] = useState(false);
  const [editing, setEditing] = useState(false);
  const [currentDraft, setCurrentDraft] = useState({} as tune_draft | composer);
  const [pendingFilter, setPendingFilter] = useState(BoolFilterState.YES);
  const [acceptedFilter, setAcceptedFilter] = useState(BoolFilterState.OFF);
  const [composers, setComposers] = useState([] as composer[])
  const [isComposer, setIsComposer] = useState(false);
  function reloadDrafts(){
    ModDataService.getAllTuneDrafts().then(result => {
      setTuneDrafts(result["data"]);
      cds.getAll().then((response) => {
        setComposers(response.data);
      }).catch(() => {
        setErrPresent(true);
        setErr("Couldn't get Composers");
      })
      ModDataService.getAllComposerDrafts().then(result => {
        setComposerDrafts(result["data"]);
      }).catch(() => {
        setErrPresent(true);
        setErr("Couldn't get ComposerDrafts");
      })
    }).catch((err) => {
      setErrPresent(true)
      if(isAxiosError(err)){
        switch(err.status){
          case 401: {
            setErr("Permission denied. (Are you logged in? Is this a moderator account?)")
            return;
          }
          default: {
            setErr("Some unknown error occured.")
            return;
          }
        }
      }
      setErr("Some error occured");
    })
  }
  useEffect(() => {
    reloadDrafts();
  },[]);
  let resFilter1 = isComposer ? composerDrafts : tuneDrafts;
  switch(pendingFilter){
    case BoolFilterState.YES:{
      resFilter1 = resFilter1.filter(item => item.pending_review);
      break;
    }
    case BoolFilterState.NO:{
      resFilter1 = resFilter1.filter(item => !item.pending_review);
      break;
    }
      //Ignore OFF case
  }
  let resFilter2 = resFilter1;
  switch(acceptedFilter){
    case BoolFilterState.YES:{
      resFilter2 = resFilter1.filter(item => item.accepted);
      break;
    }
    case BoolFilterState.NO:{
      resFilter2 = resFilter1.filter(item => !item.accepted);
      break;
    }
      //Ignore OFF case
  }
  const drafts = resFilter2.length > 0 ? resFilter2.map((item: tune_draft | composer_draft) => {
    if(isComposer){
      const comp = item as composer_draft;
      return(
        <div className="m-2">
          <button className="bg-slate-800 justify-items-start" onClick={() => {
            setCurrentDraft(item);
            setEditing(true);
            let editForm = document.getElementById("edit-form");
            //THIS MIGHT NOT WORK
            editForm && (editForm as HTMLFormElement).reset();
          }}>
            <p className="text-2xl">{comp.name}</p>
            {
              comp.pending_review
                ?
                  <p className={"text-base text-left text-yellow-200"}>
                    Pending Review
                  </p>
                  :
                  <div>
                    {
                      comp.accepted
                        ?
                          <p className={"text-base text-left text-green-200"}>
                            Accepted
                          </p>
                          :
                          <p className={"text-base text-left text-red-200"}>
                            Rejected
                          </p>
                    }
                  </div>
            }
          </button>
        </div>
      );
    }else{
      const td = item as tune_draft;
      return(
        <div className="m-2">
          <button className="bg-slate-800 justify-items-start" onClick={() => {
            setCurrentDraft(td);
            setEditing(true);
            let editForm = document.getElementById("edit-form");
            editForm && (editForm as HTMLFormElement).reset();
          }}>
            <p className="text-2xl">{td.title}</p>
            <p className='text-base text-left'>
              {(td.Composers ? td.Composers.map(comp => comp.name).join(", ")  : "No composers")}
            </p>
            {
              td.pending_review
                ?
                  <p className={"text-base text-left text-yellow-200"}>
                    Pending Review
                  </p>
                  :
                  <div>
                    {
                      td.accepted
                        ?
                          <p className={"text-base text-left text-green-200"}>
                            Accepted
                          </p>
                          :
                          <p className={"text-base text-left text-red-200"}>
                            Rejected
                          </p>
                    }
                  </div>
            }
          </button>
        </div>
      )
    }
  }) : (<div><p>No drafts found</p></div>);
  return (
    <header className='App-header w-screen overflow-x-scroll h-screen'>
      {
        !errPresent
          ? <div className="overflow-auto text-lg">
            <div>
              {
                pendingFilter === BoolFilterState.OFF 
                  ? <p className="p-2 bg-slate-800" onClick={() => {setPendingFilter(BoolFilterState.YES)}}>Filter "Pending Review"</p>
                  : <div className="flex flex-row">
                    <p>"Pending Review" Filter:</p>
                    <input type="checkbox" checked={pendingFilter === BoolFilterState.YES} onClick={() => {
                      setPendingFilter(pendingFilter === BoolFilterState.YES ? BoolFilterState.NO : BoolFilterState.YES);
                    }}/>
                    <button className="bg-slate-800 p-2" onClick={() => {setPendingFilter(BoolFilterState.OFF)}}>
                      <p>Cancel Filter</p>
                    </button>
                  </div>
              }
              {
                acceptedFilter === BoolFilterState.OFF 
                  ? <p className="p-2 bg-slate-800" onClick={() => {setAcceptedFilter(BoolFilterState.YES)}}>Filter "Accepted"</p>
                  : <div className="flex flex-row">
                    <p>"Accepted" Filter:</p>
                    <input type="checkbox" checked={acceptedFilter === BoolFilterState.YES} onClick={() => {
                      setAcceptedFilter(acceptedFilter === BoolFilterState.YES ? BoolFilterState.NO : BoolFilterState.YES);
                    }}/>
                    <button className="bg-slate-800 p-2" onClick={() => {setAcceptedFilter(BoolFilterState.OFF)}}>
                      <p>Cancel Filter</p>
                    </button>
                  </div>
              }
              <button className="p-2 bg-slate-800" onClick={() => {setIsComposer(!isComposer)}}>
                <p>Toggle between Composers and Tunes</p>
              </button>
            </div>
            <div className="flex-row">
              <p>Sort by: </p>
              <select name="Sort by" className="bg-gray-600">
                <option>Date</option>
              </select>
              <p>Reverse?</p>
              <input type="checkbox"/>
            </div>
            <div className="overflow-auto h-3/4">
              <div>
                {drafts}
              </div>
            </div>
          </div>
          : <p>{err}</p>
      }
      {
        editing && <DraftEditor draft={currentDraft} setEditing={setEditing} composers={composers} reloadDrafts={reloadDrafts} isComposer={isComposer}/>
      }
    </header>
  )
}
